/**
 * CollectionLayout
 * Layout primitives for a collection/listing page:
 * full-width wrapper, constrained container, 2-column desktop layout,
 * and mobile filter controls.
 */

import styled from '@emotion/styled';

export const FullWidth = styled.div`
  width: 100%;
`;

export const PageContainer = styled.div`
  max-width: 1170px;
  margin: 0 auto;
  padding: ${({ theme }) => theme.space.sm};
`;

export const MainContent = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.space.xl};
  width: 100%;

  @media (max-width: 900px) {
    flex-direction: column;
  }
`;

export const Sidebar = styled.aside`
  width: 256px;
  flex-shrink: 0;
  margin-bottom: 40px;

  @media (max-width: 900px) {
    display: none;
  }
`;

export const ProductsSection = styled.section`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.space.xl};
  margin-bottom: 40px;
`;

export const MobileControlsRow = styled.div`
  display: none;

  @media (max-width: 900px) {
    display: flex;
    align-items: center;
    gap: ${({ theme }) => theme.space.md};
    padding: ${({ theme }) => theme.space.sm} 0;
  }
`;

export const FilterByButton = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 10px ${({ theme }) => theme.space.md};
  font-size: ${({ theme }) => theme.fontSizes[2]}px;
  font-weight: ${({ theme }) => theme.typography.config.weight.demi};
  color: ${({ theme }) => theme.colors.text.primary};
  background: ${({ theme }) => theme.colors.background.primary};
  border: 1px solid ${({ theme }) => theme.colors.border.color};
  border-radius: ${({ theme }) => theme.radius.small};
  cursor: pointer;
  white-space: nowrap;

  &:hover {
    border-color: ${({ theme }) => theme.colors.border.highlight};
  }

  svg {
    width: 16px;
    height: 16px;
  }
`;

export const FilterBadge = styled.span`
  font-size: 11px;
  font-weight: ${({ theme }) => theme.typography.config.weight.bold};
  background: ${({ theme }) => theme.colors.text.primary};
  color: ${({ theme }) => theme.colors.background.primary};
  border-radius: 10px;
  padding: 1px 6px;
  margin-left: 2px;
`;
